import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.excitement__application_complete__title),
  subheading: () =>
    i18n.t(i18nKeys.excitement__application_complete__subheading),
  body: () => i18n.t(i18nKeys.excitement__application_complete__body),
  primaryAction: () => i18n.t(i18nKeys.common__continue),
}
